var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboundCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    enableBackground: "new 0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5-2",
    fill: "#29D773",
    cx: 75,
    cy: 75.2,
    r: 74.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "phone_callback-24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    fill: "#FFFFFF",
    d: "M56.8,74.8c4.9,9.6,12.7,17.4,22.3,22.3l7.4-7.4c0.9-0.9,2.2-1.2,3.4-0.8 c3.9,1.3,8,1.9,12.1,1.9c1.9,0,3.4,1.5,3.4,3.4V106c0,1.9-1.5,3.4-3.4,3.4c-31.8,0-57.5-25.8-57.5-57.5l0,0c0-1.9,1.5-3.4,3.4-3.4 h11.8c1.9,0,3.4,1.5,3.4,3.4c0,4.1,0.6,8.2,1.9,12.1c0.4,1.2,0.1,2.5-0.8,3.4L56.8,74.8z M102.5,50.8l-2.4-2.3L78.4,69.8 l-0.1-14.5h-3.4L75,75.6l20.3-0.1v-3.4h-14L102.5,50.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fill: "none",
    d: "M34.4,38.3h81.2v81.2H34.4V38.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboundCall);
export default __webpack_public_path__ + "static/media/inbound-call.6f63efca4b250a677157825134bc1ae4.svg";
export { ForwardRef as ReactComponent };